import { createFileRoute } from '@tanstack/react-router'
import ApiKeysPage from '@/pages/dashboard/api-keys-page'
import { ProtectedRoute, RequireModule } from '@/components/auth'
import { CAPABILITIES } from '@/constants/capabilities'
import { MODULES } from '@/constants/modules'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/sistema/api-keys',
)({
  component: function ApiKeysRoute() {
    const { dashboardId } = Route.useParams()
    
    return (
      <RequireModule module={MODULES.API} dashboardId={dashboardId}>
        <ProtectedRoute capability={CAPABILITIES.MANAGE_DASHBOARD_CONFIG}>
          <ApiKeysPage />
        </ProtectedRoute>
      </RequireModule>
    )
  },
})
